import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRepairsMaintenance = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#b8d0dd",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.5252 5.53071L10.4341 3.43961L12.5252 1.34852C12.0895 1.08713 11.5668 1 11.044 1C8.86577 1 7.12318 2.74258 7.12318 4.92081C7.12318 5.35645 7.21031 5.70497 7.29744 6.14062L1.54692 10.4099C0.849889 10.9327 0.849889 11.8911 1.37266 12.501L3.37663 14.5921C3.98654 15.202 4.94496 15.1149 5.46773 14.4179L9.73706 8.66736C10.1727 8.75449 10.6083 8.84162 11.044 8.84162C13.2222 8.84162 14.9648 7.09904 14.9648 4.92081C14.9648 4.39803 14.8777 3.87526 14.7034 3.43961L12.5252 5.53071Z",
		fill: "currentColor",
		fillOpacity: .25,
		stroke: "currentColor"
	})
});
export default SvgRepairsMaintenance;
